// @flow
// import _ from 'lodash';
import { connect } from 'react-redux';
import Item from './Item';

const mapState = (state: ClientStore) => ({});
const mapDispatch = {};

export default connect(mapState, mapDispatch)(Item);
